import { IWebchatWidgetProvider } from 'modules/webchat/domain/providers';

import CallbellWebchatWidgetProvider from './implementations/CallbellWebchatWidgetProvider';

let instance: IWebchatWidgetProvider | null = null;

export default function makeWebchatWidgetProvider() {
  if (!instance) {
    instance = new CallbellWebchatWidgetProvider();
  }

  return instance;
}
